// extracted by mini-css-extract-plugin
export default {"game":"Game_game__YH4rG","endgame__grid":"Game_endgame__grid__oPLBT","row":"Game_row__4qOt1","copy__grid":"Game_copy__grid__H0oF+"};